/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import AllPayors from './AllPayors/index'
import Payors from './Payors/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content"
  
}) {
  return (<React.Fragment
>
<AllPayors
  viewPath={`${viewPath}/AllPayors`}
/>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Payors
  viewPath={`${viewPath}/Payors`}
/>
</div>
{children}
</React.Fragment>)
}